export default "query contactRoles{\n    contactRoles\n}";